import axios from 'axios'
import store from '@/store/index.js'
import router from '@/router'

// Add a request interceptor
axios.interceptors.request.use(
    config => {
        const user = JSON.parse(localStorage.getItem('user'))

        if (user && user.token) {
            config.headers.Authorization = 'Bearer ' + user.token
        }

        if (user && user.id) {
            config.params = {}
            config.params['access_token'] = user.id
        }

        store.commit('SET_LOADING', true)

        return config
    },
    error => {
        store.commit('SET_LOADING', false)

        Promise.reject(error)
    })

// Add a response interceptor
axios.interceptors.response.use((response) => {
    store.commit('SET_LOADING', false)

    return response
    }, function (error) {
        store.commit('SET_LOADING', false)
        console.log(error)
        if (error.response && error.response.status === 401) {
            store.dispatch('auth/logout').then(
                () => {
                    if (router.currentRoute.name !== 'Login')
                    router.push({ name: 'Login' })
                },
                error => {
                    this.message = (error.response && error.response.data) || error.message || error.toString()
                },
            )
        }

        return Promise.reject(error)
})
